<template>
    <div>
        <Toolbar>
            <!-- LEFT -->
            <BackButton :to="__('general.subscriptions')" :href="$route('subscriptions')"/>

            <!-- RIGHT -->
            <template v-slot:right>
                <ToolbarLink v-if="Permission.CREATE_SUBSCRIPTION_BUNDLES"
                             :href="$route('subscriptions.bundles.create')">
                    <i class="fas fa-plus-square mr-1"/>
                    {{ __('actions.create_thing', {thing: __('subscriptions.bundle')}) }}
                </ToolbarLink>
            </template>
        </Toolbar>

        <Card>
            <template v-slot:title>
                {{ __('subscriptions.bundles') }}
            </template>
            <template v-slot:description>
                {{ __('subscriptions.view_bundles_description') }}
            </template>

            <!-- BUNDLES -->
            <Bundle v-for="bundle in paginatedBundles.data" :bundle="bundle" :key="bundle.id"/>

            <!-- PAGINATION -->
            <Pagination class="mt-3"
                        :pagination="paginatedBundles"
                        :inertia-options="{only: ['paginatedBundles']}"
                        disable-when-one-page
            />
        </Card>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';
import Bundle from "@components/Subscriptions/Bundles/Bundle.vue";
import Pagination from "@components/TableComponents/Pagination.vue";
import BackButton from "@components/BackButton.vue";
import Card from "@components/Cards/Card.vue";
import Toolbar from "@components/Toolbar.vue";
import ToolbarLink from "@components/ToolbarLink.vue";
import {PermissionsMixin} from "@js/permissions";

export default {
    components: {ToolbarLink, Toolbar, Card, BackButton, Pagination, Bundle, Link},

    mixins: [PermissionsMixin],

    props: {
        paginatedBundles: Object
    }
};
</script>
